import useAuthenticatedRequest from '../../Utils/TokenrRefreshUtils';
import { useContext, useRef, useState } from 'react';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';

import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

import { OrgInfoContext } from '../../context/OrgInfoProvider';

import { Avatar } from 'primereact/avatar';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { FileUpload } from 'primereact/fileupload';
import { FloatLabel } from 'primereact/floatlabel';
import { MegaMenu } from 'primereact/megamenu';
import { Sidebar } from 'primereact/sidebar';
import { TieredMenu } from 'primereact/tieredmenu';
import { Toast } from 'primereact/toast';
import { Tooltip } from 'primereact/tooltip';

import baseUserPic from "../../images/Random_user_pic.png";
import usFlag from "../../images/USD.svg";
import EUFlag from "../../images/EUR.svg";
import classes from "./PageBar.module.css";
import commonStyle from "./CommonStyles.module.css";
import { Translate } from '../../Utils/TranslationUtils';
import useApi from '../../Utils/BackendClient';
import { Dropdown } from 'primereact/dropdown';
import { ProgressSpinner } from 'primereact/progressspinner';
import { DisplayErrors } from '../../Utils/ErrorHandler';


const PageBar = params => {

    const [isDarkTheme, setIsDarkTheme] = useState(Cookies.get("isDarkTheme") === "true");
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 932);
    const [userDialogVisible, setUserDialogVisible] = useState(false);
    const [showChangePasswordMenu, SetShowChangePasswordMenu] = useState(false);
    const [showUploadMenu, setShowUploadMenu] = useState(false);
    const [userOrganizations, setUserOrganizations] = useState(null);
    const [userOrganization, setUserOrganization] = useState(Number(Cookies.get("organization")));
    const [userLogo, setUserLogo] = useState();
    //const [count, setCount] = useState(0);

    const orgctx = useContext(OrgInfoContext);
    const authenticatedRequest = useAuthenticatedRequest();
    const menu = useRef(null);
    //const notifMenu = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();

    const { fetchCurrenciesList, fetchUserOrganization, saveUserTheme, switchOrganization } = useApi();

    const toast = useRef(null);

    useEffect(() => {
        const avatar = Cookies.get("avatar");
        setUserLogo(avatar !== null && avatar !== "" ? avatar : baseUserPic);
    }, []);

    const handleResize = () => {
        setIsMobile(window.innerWidth <= 932);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (!Cookies.get("USD")) {

            const fetchData = async () => {
                
                const response = await fetchCurrenciesList();

                if (response.status === 200) {

                    console.log(response);

                    response.data.forEach(rate => {
                        Cookies.set(rate.currency_short, rate.currency_rate);
                        Cookies.set(rate.currency_short + "Date", rate.last_rate_date)
                    });
                }
            };

            fetchData();
        }
    }, [fetchCurrenciesList]);

    useEffect(() => {
        const getUserOrganizations = async () =>{
            const response = await fetchUserOrganization();

            if (response.status === 200){
                setUserOrganizations(response.data);
            }
        }

        getUserOrganizations()
    }, [fetchUserOrganization]);

   /* useEffect(() => {
        const es = new EventSource(`${process.env.REACT_APP_BACKEND_URL}orders/count_orders_stream/?organization_id=${Cookies.get("organization")}`);

         es.addEventListener("status", (e) => {
            const data = JSON.parse(e.data);
            setCount(data.count_new_orders)
            console.log("Status update:", data);
        });

        return () => {
        es.close();
        console.log("EventSource closed");
    };

    },[]); */

    const switchOrg = async(id) => {

        const request = {
            organization_id : id
        }

        const response = await switchOrganization(request);

        if(response.status === 200){
            Cookies.set("authToken", response.data.access);
            Cookies.set("refreshToken", response.data.refresh);
            Cookies.set("organization", response.data.organization_id);

            Cookies.remove("USD");
            Cookies.remove("EUR");

            navigate(0);
        }

        setUserOrganization(id);
    }

    let paths = location.pathname.split('/').filter((path) => path !== '');
    const complexpathes = ["editproductgroup", "editproduct", "editgroup", "editservice", "currencyrates", "edituser", 
        "editdivision", "editreception", "editcounteragent", "editsale", "edituserrole", "editproductsreturn", "editreturn", "editorder", "editexternalproduct", "editexternalact"];

    if (paths.some(path => complexpathes.includes(path))) {

        const elementCount = paths.length;

        const newelement = paths[elementCount - 2];

        let newpath = paths.slice(0, elementCount - 2);

        newpath.push(newelement);

        paths = newpath;
    }

    const getTransalation = path => {

        let returnTranslation = Translate(path);

        complexpathes.forEach(element => {
            if (path.startsWith(element)) {
                const names = path.split(" ");

                returnTranslation = Translate(names[0]);
            }
        });

        return returnTranslation;
    }

    const items = paths.map((path, index) => ({
        label: getTransalation(path),
        url: `/${paths.slice(0, index + 1).join('/')}`,
    }));

    const home = { icon: 'pi pi-home', url: '/widgets' };

    const startElement = (<div className='flex'>
        <Button icon="pi pi-bars" severity="secondary" outlined className="mr-2" onClick={() => params.changeNavBarState()} />
        {!isMobile && <BreadCrumb model={items} home={home} className={isDarkTheme ? classes.breadcrumb : classes.lightBreadCrumbs} />}
    </div>
    );

    const mobileBreadCrumbs = (<div className='flex'>
        <BreadCrumb model={items} home={home} className={isDarkTheme ? classes.breadcrumb : classes.lightBreadCrumbs} />
    </div>
    );

    const decodedToken = jwtDecode(Cookies.get("authToken"));

    const dialogFormik = useFormik({
        initialValues: {
            old_password: '',
            password: '',
            password2: ''
        },
        validate: values => {
            const errors = {};

            if (values.old_password === null || values.old_password === "") {
                errors.old_password = "Поле не повинне бути пустим";
            }

            if (values.password === null || values.password === '') {
                errors.password = "Поле не повинне бути пустим";
            }
            if (values.password2 === null || values.password2 === '') {
                errors.password2 = "Поле не повинне бути пустим";
            }

            if (values.password !== values.password2) {
                errors.password2 = "Паролі не співпадають";
            }

            return errors;
        },
        onSubmit: values => {
            const changeUserPassword = async () => {

                const url = process.env.REACT_APP_BACKEND_URL + "auth/change_password/" + decodedToken.user_id + "/";
                const options = {
                    method: "PUT",
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(values)
                };

                const response = await authenticatedRequest(url, options);

                if (response.status === 200) {
                    SetShowChangePasswordMenu(false);
                    toast.current.show({ severity: 'success', summary: 'Success', detail: 'Пароль успішно змінено', life: 3000 });
                    dialogFormik.resetForm();
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Помилка при зміні паролю', life: 3000 });
                }
            }

            changeUserPassword();
        }
    });

    const handleUserClick = () => {
        setUserDialogVisible(true);
    }

    const ShowChangePasswordMenu = () => {
        SetShowChangePasswordMenu(true);
    };

    const HideChangePasswordMenu = () => {
        SetShowChangePasswordMenu(false);
    };

    const HideDialogMessageHandler = () => {
        setShowUploadMenu(false);
        setUserDialogVisible(false);
    }

    const handleLogout = () => {
        setUserDialogVisible(false);
        Cookies.remove('authName');
        Cookies.remove('USDRate');
        orgctx.cleanOrgInfo();
        params.setUnloginned(true);
    };

    const DeleteLogoHandler = async () => {

        let formData = new FormData();
        formData.append('user_id', decodedToken.user_id.toString())

        const url = process.env.REACT_APP_BACKEND_URL + "auth/delete_logo/";
        const options = {
            method: "DELETE",
            body: formData,
            redirect: "follow"
        };

        const response = await authenticatedRequest(url, options);
        Cookies.remove("avatar");
        setUserLogo(baseUserPic);
        console.log(response);
    }

    const Upload = uploadEvent => {

        const uploadAvatar = async () => {

            let formData = new FormData();
            formData.append('user_id', decodedToken.user_id.toString())
            formData.append('logo', uploadEvent.files[0], uploadEvent.files[0].name)

            const UploadLogo = async (url, method) => {

                const backEndUrl = process.env.REACT_APP_BACKEND_URL + "auth/" + url;
                const options = {
                    method: method,
                    body: formData,
                    redirect: "follow"
                };

                const response = await authenticatedRequest(backEndUrl, options);
                console.log(response);
                const parsedResponse = await response.json();
                console.log(parsedResponse);

                Cookies.set("avatar", parsedResponse.logo_url);
                setUserLogo(parsedResponse.logo_url);
            }

            if (Cookies.get("avatar") === null || Cookies.get("avatar") === undefined) {
                UploadLogo("upload_logo/", "POST")
            }
            else {
                UploadLogo("update_logo/", "PUT")
            }
        }

        uploadAvatar();
        setShowUploadMenu(false);
    }

    const fullName = decodedToken.first_name + " " + decodedToken.last_name;

    const changeTheme = async (isDark) => {

        const request = {
            theme: isDark ? "DARK" : "LIGHT"
        }

        const response = await saveUserTheme(request);

        if (response.status === 200) {
            setIsDarkTheme(isDark);
            Cookies.set("isDarkTheme", isDark);
            params.switchTheme(isDark);
        }
        else{
            DisplayErrors(response.error, toast);
        }
    }

    const menuItems = [
        {
            label: "Вибрати тему",
            icon: "pi pi-sun",
            items: [
                {
                    label: "Світла тема",
                    icon: "pi pi-sun",
                    command: () => {
                        changeTheme(false);
                    }
                },
                {
                    label: "Темна тема",
                    icon: "pi pi-moon",
                    command: () => {
                        changeTheme(true);
                    }
                }
            ]
        },
        {
            label: 'Деталі користувача',
            icon: 'pi pi-user',
            command: () => {
                handleUserClick();
            },
        },
        {
            label: 'Вийти',
            icon: 'pi pi-sign-out',
            command: () => {
                handleLogout();
            },
        },
    ];

    /*const notificationItems = [
        count > 0 ? {
            label: `У вас ${count} нових замовлення`,
            icon: 'pi pi-letter',
            command: () => {
                navigate("/orders");
            },
        } : {
            label: `Немає нових сповіщень`,
            icon: 'pi pi-letter',
        },
    ] */

    const rightBlock = (<div className={`${classes["flex-container"]}`}>
        {userOrganizations && userOrganizations.length > 1 && <Dropdown
            value={userOrganization}
            onChange={e => switchOrg(e.value)}
            options={Array.from(new Map(userOrganizations?.map(item => [item.id, item])).values())}
            optionLabel="name"
            optionValue="id"
            className="mr-5"
        />}
        {Cookies.get("USD") ? <div className='flex flex-column justify-content-center align-items-center mr-2'>
            <div className='flex-row'>
                <img src={usFlag} alt="US Flag" width="20" height="15" />
                {!isMobile && <span className="text-400 font-medium ml-2">USD</span>}
            </div>
                <div className="text-900 font-medium text-xl">{Cookies.get("USD")}</div>
        </div> : <ProgressSpinner style={{width: '50px', height: '50px'}} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />}

        {Cookies.get("EUR") ? <div className='flex flex-column justify-content-center align-items-center'>
            <div className='flex-row'>
                <img src={EUFlag} alt="EU Flag" width="20" height="15" />
                {!isMobile && <span className="text-500 font-medium ml-2">EUR</span>}
            </div>
            <div className="text-900 font-medium text-xl">{Cookies.get("EUR")}</div>
        </div> : <ProgressSpinner style={{width: '50px', height: '50px'}} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />}

        {/*<div className={`${classes["flex-item"]} ${classes.userBlock}`}>
            <i
                className="pi pi-bell p-overlay-badge ml-3 mr-4"
                style={{ fontSize: '1.5rem' }}
                onClick={(e) => notifMenu.current.toggle(e)} // Toggle menu on click
            >
                {count > 0 && <Badge value={count} severity="secondary"></Badge>}
            </i>
            <Menu
                model={notificationItems}
                popup
                ref={notifMenu}
            />
        </div>*/}

        <div className={`${classes["flex-item"]} ${classes.userBlock} ml-3`}>

            <Avatar
                image={userLogo}
                size="large"
                style={{ cursor: 'pointer' }}
                onClick={(e) => menu.current.toggle(e)} // Toggle menu on click
            />
            <TieredMenu
                model={menuItems}
                popup
                ref={menu}
            />
        </div>
    </div>);

    return <div>
        <Toast ref={toast} position="top-center" />
        <MegaMenu orientation="horizontal" start={startElement} end={rightBlock} className={isDarkTheme ? classes.darkMegaMenu : classes.lightMegaMenu} />
        {isMobile && <MegaMenu orientation="horizontal" start={mobileBreadCrumbs} className={isDarkTheme ? classes.darkMegaMenu : classes.lightMegaMenu}/>}
        <Sidebar
            visible={userDialogVisible}
            position='right'
            onHide={HideDialogMessageHandler}
        >
            <div className="grid">
                <div className="col-12">
                    <div className="text-center">
                        <img
                            className="rounded-circle"
                            width="150px"
                            src={userLogo}
                            alt="User Avatar"
                        />
                    </div>
                    {!showUploadMenu && <div className="text-center">
                        <Tooltip target=".custom-changelogo-btn" content="Змінити лого" position="left" />
                        <Tooltip target=".custom-deletelogo-btn" content="Видалити лого" position="right" />
                        <Button icon="pi pi-arrow-right-arrow-left" className={`p-button-rounded p-button-danger ${commonStyle.editButton} mt-2 custom-changelogo-btn`} onClick={() => setShowUploadMenu(true)} />
                        <Button icon="pi pi-trash" className={`p-button-rounded p-button-danger ${commonStyle.deleteButton} custom-deletelogo-btn ml-1`} onClick={DeleteLogoHandler} type="button" />
                    </div>}
                    {showUploadMenu && <div className="text-center mt-3">
                        <FileUpload
                            mode="basic"
                            name="demo[]"
                            accept="image/*"
                            maxFileSize={1000000}
                            customUpload
                            uploadHandler={Upload}
                        >
                        </FileUpload>
                    </div>}
                </div>
                <div className="col-12">
                    <div className='flex flex-column align-items-center justify-content-center'>
                        <h2 className='mb-0'>{fullName} </h2>
                        {decodedToken.position !== undefined && <h4>{decodedToken.position}</h4>}
                        <span className='mb-4'>{decodedToken.email}</span>
                    </div>
                    {!showChangePasswordMenu && (<div className='flex align-items-center justify-content-center'>
                        <Button label="Змінити пароль" severity="info" className={`${commonStyle.editButton} ${commonStyle.inputTextStyle}`} onClick={ShowChangePasswordMenu} />
                    </div>)}
                    {showChangePasswordMenu && (<form onSubmit={dialogFormik.handleSubmit} style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                        <div>
                            <div className={commonStyle.dialogFormInput}>
                                <div className="p-inputgroup flex-column md:w-17rem">
                                    <FloatLabel>
                                        <InputText
                                            name="old_password"
                                            value={dialogFormik.values.old_password}
                                            onChange={(e) => { dialogFormik.setFieldValue('old_password', e.target.value) }}
                                            className={dialogFormik.errors.old_password && dialogFormik.touched.old_password ? 'p-invalid' : ''}
                                        />
                                        <label>Старий пароль</label>
                                    </FloatLabel>
                                    {dialogFormik.errors.old_password && dialogFormik.touched.old_password && (<small className={commonStyle.errorSmall}>{dialogFormik.errors.old_password}</small>)}
                                </div>
                            </div>
                            <div className={commonStyle.dialogFormInput}>
                                <div className="p-inputgroup flex-column md:w-17rem">
                                    <FloatLabel>
                                        <InputText
                                            name="password"
                                            value={dialogFormik.values.password_password}
                                            onChange={(e) => { dialogFormik.setFieldValue('password', e.target.value) }}
                                            className={dialogFormik.errors.password && dialogFormik.touched.password ? 'p-invalid' : ''}
                                        />
                                        <label>Новий пароль</label>
                                    </FloatLabel>
                                    {dialogFormik.errors.password && dialogFormik.touched.password && (<small className={commonStyle.errorSmall}>{dialogFormik.errors.password}</small>)}
                                </div>
                            </div>
                            <div className={commonStyle.dialogFormInput}>
                                <div className="p-inputgroup flex-column md:w-17rem">
                                    <FloatLabel>
                                        <InputText
                                            name="password2"
                                            value={dialogFormik.values.password2}
                                            onChange={(e) => { dialogFormik.setFieldValue('password2', e.target.value) }}
                                            className={dialogFormik.errors.password2 && dialogFormik.touched.password2 ? 'p-invalid' : ''}
                                        />
                                        <label>Підтвердіть новий пароль</label>
                                    </FloatLabel>
                                    {dialogFormik.errors.password2 && dialogFormik.touched.password2 && (<small className={commonStyle.errorSmall}>{dialogFormik.errors.password2}</small>)}
                                </div>
                            </div>
                            <div className="flex flex-column align-items-center justify-content-center">
                                <Button label="Змінити пароль" type="submit" severity="success" className={`${commonStyle.addButton} mt-2 ${commonStyle.inputTextStyle}`} />
                                <Button label="Відмінити" type="button" severity="info" className={`${commonStyle.editButton} mt-1 ${commonStyle.inputTextStyle}`} onClick={HideChangePasswordMenu} />
                            </div>
                        </div>
                    </form>)}
                </div>
            </div>
            <div className="flex align-items-center justify-content-center">
                <Button label="Вийти" className={`${commonStyle.deleteButton} ${commonStyle.inputTextStyle}`} onClick={handleLogout} />
            </div>
        </Sidebar>
    </div>;
};

export default PageBar;